import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  EnquiriesFilter,
  EnquiriesResponse,
  EnquiryDetailResponse,
  EnquiryMutationResponse,
  UpdateEnquiryStatusPayload,
} from "../types/enquiries.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.enquiries;

const failure = (error: unknown, fallback: string) => ({
  success: false,
  statusCode: 500,
  message: error instanceof Error ? error.message : fallback,
  resData: null,
});

export const enquiriesService = {
  async list(filter: EnquiriesFilter): Promise<EnquiriesResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<EnquiriesResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(
        error,
        "Failed to load enquiries due to an unexpected error.",
      ) as unknown as EnquiriesResponse;
    }
  },

  async details(id: number | string): Promise<EnquiryDetailResponse> {
    try {
      return await apiClient<EnquiryDetailResponse>(endpoints.details(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(
        error,
        "Failed to load enquiry details due to an unexpected error.",
      ) as unknown as EnquiryDetailResponse;
    }
  },

  async updateStatus(
    id: number | string,
    payload: UpdateEnquiryStatusPayload,
  ): Promise<EnquiryMutationResponse> {
    try {
      return await apiClient<EnquiryMutationResponse>(endpoints.update(id), {
        method: "PATCH",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(
        error,
        "Failed to update enquiry status due to an unexpected error.",
      ) as unknown as EnquiryMutationResponse;
    }
  },

  async delete(id: number | string): Promise<EnquiryMutationResponse> {
    try {
      return await apiClient<EnquiryMutationResponse>(endpoints.delete(id), {
        method: "DELETE",
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(
        error,
        "Failed to delete enquiry due to an unexpected error.",
      ) as unknown as EnquiryMutationResponse;
    }
  },
};
